import AdditionalNews from '@/components/AdditionalNews'

export function init () {
  const root = document.querySelector('.additional-news')
  const header = document.getElementById('header')
  const mainSlider = document.getElementById('main-slider')
  if (root) {
    const component = new AdditionalNews(root, header, mainSlider)
    component.init() 
  }
}


// WEBPACK FOOTER //
// ./src/modules/additionalNews.js